import { de } from './de';

export const it: typeof de = {
  language: {
    de: 'Deutsch',
    fr: 'Français',
    it: 'Italiano',
  },
  myApplications: {
    title: 'Le mie candidature',
    archive: 'Archivio',
    archiveCount: 'Archivio ({{count}})',
    backToList: 'Torna a Le mie candidature',
    archiveIntro:
      'Candidature concluse e archiviate. Le scuole non vedono cosa archivi.',
    filterLabel: 'Filtra per stato',
    all: 'Tutte',
    listLabel: 'Le tue candidature',
    archiveListLabel: 'Candidature archiviate',
    loadFailed: 'Non è stato possibile caricare le tue candidature.',
    retry: 'Riprova',
    empty: {
      title: 'Ancora nessuna candidatura',
      text: 'Qui vedi a che punto sono le tue candidature. Niente di adatto? Invia una candidatura spontanea alla scuola che preferisci.',
      jobs: 'Vedi i posti aperti',
      schools: 'Scopri le scuole',
      archiveTitle: 'L’archivio è vuoto',
      archiveText:
        'Qui finiscono le candidature che archivi. Le scuole non vedono cosa archivi.',
      filtered: 'Nessuna candidatura con questo stato.',
    },
    menu: {
      label: 'Azioni per {{title}}',
      posting: 'Vedi l’annuncio',
      school: 'Vedi il profilo della scuola',
      withdraw: 'Ritira la candidatura',
      archive: 'Archivia',
      restore: 'Togli dall’archivio',
    },
    withdraw: {
      title: 'Ritirare la candidatura?',
      text: 'Ritiri la tua candidatura «{{title}}» presso {{school}}. La scuola vede la candidatura con lo stato «Ritirata» e non può più elaborarla. L’operazione non può essere annullata.',
      confirm: 'Ritira la candidatura',
      cancel: 'Annulla',
      done: 'Candidatura ritirata.',
      failed:
        'Non è stato possibile ritirare la candidatura. Forse la scuola l’ha elaborata nel frattempo. Ricarica la pagina e riprova.',
    },
    archived: 'Candidatura archiviata.',
    restored: 'Candidatura di nuovo in Le mie candidature.',
    archiveFailed: 'Non ha funzionato. Riprova.',
  },
  installHint: {
    close: 'Chiudi avviso',
    install: "Installa l'app",
    applications: {
      title: 'Le risposte della scuola subito sul telefono',
      text: 'Aggiungi Bildigsnetz alla schermata Home. Così ricevi una notifica push appena una scuola risponde.',
    },
    home: {
      title: 'Bildigsnetz come app sul telefono',
      text: 'Aggiungi Bildigsnetz alla schermata Home. Così ricevi messaggi e risposte subito come notifica push.',
    },
    sheet: {
      title: 'Bildigsnetz sulla schermata Home',
      ok: 'Ho capito',
      ios: {
        '1': 'In Safari tocca «Condividi» in basso.',
        '2': 'Scegli «Aggiungi alla schermata Home».',
        '3': 'Apri Bildigsnetz da lì e attiva le notifiche push.',
      },
      android: {
        '1': 'Nel browser tocca il menu in alto a destra.',
        '2': 'Scegli «Installa app» o «Aggiungi a schermata Home».',
        '3': 'Apri Bildigsnetz da lì e attiva le notifiche push.',
      },
    },
  },
  applicationDetail: {
    head: 'La tua candidatura del {{date}}',
    headInitiative: 'La tua candidatura spontanea del {{date}}',
    status: 'Stato',
    progress: 'Avanzamento della tua candidatura',
    since: 'dal {{date}}',
    pending: 'in sospeso',
    step: {
      sent: 'Inviata',
      review: 'In esame',
      interview: 'Colloquio',
      decision: 'Decisione',
      answer: 'Risposta della scuola',
      accepted: 'Accettata',
      rejected: 'Rifiutata',
      withdrawn: 'Ritirata',
    },
    state: {
      done: '(completato)',
      now: '(passo attuale)',
      todo: '(da fare)',
      yes: '(accettata)',
      no: '(conclusa)',
    },
    text: {
      PENDING:
        'La scuola sta esaminando la tua candidatura. Riceverai un e-mail non appena lo stato cambia.',
      PENDING_INITIATIVE:
        'La scuola ha ricevuto la tua candidatura spontanea e ti ricontatterà.',
      INVITED:
        "La scuola vorrebbe conoscerti. Trovi l'invito nella chat e nelle tue e-mail.",
      ACCEPTED:
        'Congratulazioni! La scuola ti ha dato una risposta positiva. Discuterà direttamente con te i prossimi passi; trovi il messaggio nella chat e nelle tue e-mail.',
      REJECTED:
        "La scuola ha scelto un'altra persona. Trovi il suo messaggio nella chat e nelle tue e-mail. In bocca al lupo per la tua ricerca!",
      WITHDRAWN:
        'Hai ritirato questa candidatura. La scuola non la elabora più.',
    },
    withdraw: 'Ritira la candidatura',
    withdrawInitiative: 'Ritira la candidatura spontanea',
    posting: 'Descrizione del posto',
    schoolProfile: 'Profilo della scuola',
    authorityProfile: 'Profilo del comune scolastico',
    letter: 'Messaggio alla scuola',
    letterReviewer: 'Messaggio alla scuola / lettera di motivazione',
    attachments: 'Allegati',
    cv: 'Curriculum vitae',
    tandemCv: '2° CV per candidatura in tandem',
    qualifications: 'Diplomi e certificati',
    additionalDocs: 'Certificati di lavoro e altro',
    view: 'Mostra',
  },
  jobArchive: {
    rejectAll: 'Rifiutare tutte le {{count}} candidature aperte',
    rejectAllHint:
      'Dopo l’archiviazione si apre il rifiuto con il testo standard. Puoi adattarlo prima dell’invio.',
    tooMany:
      'Più di {{max}} candidature aperte: rifiutale nella panoramica delle candidature in gruppi di massimo {{max}}.',
  },
  settings: {
    title: 'Impostazioni',
    crumb: 'Le tue impostazioni',
    back: 'Indietro',
    save: 'Salva',
    change: 'Modifica',
    next: 'Avanti',
    cancel: 'Annulla',
    failed: 'Si è verificato un errore. Riprova più tardi.',
    currentPassword: 'Password attuale',
    forgotPassword: 'Password dimenticata?',
    tile: {
      account: 'Account utente',
      accountSub: 'Dati di accesso e impostazioni personali',
      privacy: 'Privacy',
      privacySub: 'Qui decidi quali dei tuoi dati sono visibili',
      notifications: 'Notifiche',
      notificationsSub: 'Notifiche via e-mail e proposte di posti',
      subscription: 'Abbonamento',
      subscriptionSub: 'Gestisci qui le impostazioni del tuo abbonamento',
    },
    account: {
      access: 'Dati di accesso',
      contact: 'Dati di contatto',
      contactSub: 'Domicilio e numero di telefono',
      contactSubEmail: 'Domicilio, e-mail e numero di telefono',
      password: 'Cambia password',
      personal: 'Impostazioni personali',
      name: 'Cambia nome',
      delete: 'Elimina profilo',
      deleteSub: 'Non vuoi più usare Bildigsnetz?',
    },
    name: {
      crumb: 'Nome',
      intro:
        'I tuoi dati personali sono la base del tuo profilo Bildigsnetz. Se li modifichi qui, verifichiamo le modifiche e le attiviamo manualmente.',
      info: 'Indicazioni importanti sul nome',
      firstName: 'Nome',
      lastName: 'Cognome',
      reason: 'Motivo della modifica',
      saved: 'Nome modificato.',
      rulesTitle: 'Per il tuo nome valgono due regole:',
      rule1:
        '1. Inserisci nome e cognome per intero (p. es. «Max» / «Meier», non «M.» / «Meier»).',
      rule2:
        '2. Inserisci il tuo vero nome (non «Bibi Blocksberg» o «James Bond»).',
      action: 'Cambia nome',
    },
    email: {
      title: 'Cambia indirizzo e-mail',
      intro:
        'Qui puoi cambiare l’indirizzo e-mail con cui accedi e a cui ti inviamo le notifiche.',
      current: 'Il tuo indirizzo e-mail attuale',
      edulog:
        'Accedi tramite Edulog. Se vuoi cambiare il tuo indirizzo e-mail, rivolgiti al nostro',
      support: 'supporto',
      new: 'Nuovo indirizzo e-mail',
      invalid: 'Inserisci un indirizzo e-mail valido.',
      sentTitle: 'Cambio dell’indirizzo e-mail richiesto',
      sentText:
        'Ti abbiamo inviato un link a {{email}}. Cliccaci sopra per confermare il nuovo indirizzo. Dopo accedi con il nuovo indirizzo. Fino ad allora vale il tuo indirizzo attuale.',
    },
    password: {
      title: 'Cambia password',
      intro: 'Imposta qui la nuova password con cui accedi a Bildigsnetz.',
      saved: 'Password aggiornata.',
      resetSent: 'Ti inviamo un’e-mail al tuo indirizzo:',
      resetHint: 'Clicca sul link nell’e-mail per cambiare la tua password.',
    },
    delete: {
      title: 'Elimina profilo',
      intro:
        'Peccato che tu non voglia più usare Bildigsnetz. Sei una parte importante del sistema educativo svizzero e ci piacerebbe tenerti. Tieni presente che eliminiamo davvero i dati del tuo profilo. L’operazione non può essere annullata.',
      ownerTitle: 'Prima trasferisci la responsabilità principale',
      ownerText:
        'Sei proprietario/a delle seguenti organizzazioni. Affinché non restino senza una persona responsabile, trasferisci la responsabilità principale a un/a altro/a Super Admin prima di eliminare il tuo profilo.',
      toTeam: 'Vai a Team & autorizzazioni',
      blocked: 'Eliminazione non possibile',
      deleting: 'Eliminazione del profilo …',
      confirm: 'Ci dispiace perderti come membro.',
      deleted: 'Il profilo è stato eliminato.',
      failed: 'Non è stato possibile eliminare il profilo. Riprova più tardi.',
    },
    privacy: {
      title: 'Privacy',
      analytics: 'Analytics e tracciamento',
      analyticsText:
        'Questi cookie ci permettono di capire come usi il nostro sito, così da poterlo migliorare in modo mirato.',
      saved: 'Privacy aggiornata.',
    },
    contact: {
      title: 'Dati di contatto',
      email: 'E-mail',
      changeEmail: 'Cambiare l’indirizzo e-mail?',
      phone: 'Numero di telefono',
      saved: 'Dati di contatto salvati.',
    },
    notifications: {
      title: 'Notifiche via e-mail',
      newsletter: 'Desidero ricevere informazioni importanti con la newsletter',
      chat: 'Notifica quando ricevo un messaggio in chat',
      alwaysOn: 'Sempre attiva',
      saved: 'Impostazioni e-mail aggiornate.',
      section: {
        team: 'Profilo della scuola & team',
        hr: 'Processi HR',
        admin: 'Modifiche amministratori',
        account: 'Account',
      },
      item: {
        member_joined: {
          label: 'Nuovo membro del team',
          description:
            'Quando una persona entra a far parte della tua scuola o del tuo comune scolastico.',
        },
        member_left: {
          label: 'Membro del team uscito',
          description:
            'Quando un membro lascia la tua scuola o il tuo comune scolastico.',
        },
        member_removed: {
          label: 'Rimosso/a da un team',
          description:
            'Quando un’amministratrice o un amministratore ti rimuove da un team.',
        },
        application_received: {
          label: 'Nuova candidatura',
          description:
            'Quando arriva una nuova candidatura per uno dei tuoi posti.',
        },
        application_withdrawn: {
          label: 'Candidatura ritirata',
          description:
            'Quando una candidata o un candidato ritira una candidatura.',
        },
        application_confirmation_copy: {
          label: 'Copia della conferma di ricezione',
          description:
            'Una copia della conferma di ricezione inviata a chi si candida.',
        },
        job_runtime_ending: {
          label: 'Fine della durata di pubblicazione',
          description:
            'Quando la durata di pubblicazione di un annuncio sta per scadere.',
        },
        admin_added: {
          label: 'Diritti di amministratore ricevuti (scuola)',
          description:
            'Quando ricevi diritti di amministratore per una scuola.',
        },
        admin_revoked: {
          label: 'Diritti di amministratore revocati (scuola)',
          description:
            'Quando ti vengono revocati i diritti di amministratore per una scuola.',
        },
        authority_admin_added: {
          label: 'Diritti di amministratore ricevuti (comune scolastico)',
          description:
            'Quando ricevi diritti di amministratore per un comune scolastico.',
        },
        authority_admin_revoked: {
          label: 'Diritti di amministratore revocati (comune scolastico)',
          description:
            'Quando ti vengono revocati i diritti di amministratore per un comune scolastico.',
        },
        account_deleted: {
          label: 'Account eliminato',
          description: 'Conferma quando il tuo account è stato eliminato.',
        },
      },
    },
    push: {
      title: 'Notifiche su questo dispositivo',
      intro:
        'Per nuovi messaggi in chat e nuove candidature compaiono una notifica e un numero sull’icona dell’app, anche quando Bildigsnetz è chiuso.',
      active: 'Attive su questo dispositivo',
      off: 'Disattiva',
      enable: 'Attiva le notifiche',
      needsInstall:
        'Su iPhone e iPad le notifiche funzionano solo se Bildigsnetz è nella schermata Home: nel browser tocca l’icona di condivisione e scegli «Aggiungi alla schermata Home». Poi apri Bildigsnetz dalla nuova icona e attivale qui.',
      denied:
        'Le notifiche per Bildigsnetz sono bloccate. Puoi consentirle nelle impostazioni del browser o del dispositivo e poi ricaricare la pagina.',
      unavailable: 'Le notifiche non sono ancora attivate.',
      unsupported: 'Questo browser non supporta le notifiche.',
      error: 'Non ha funzionato. Riprova.',
      retry: 'Riprova',
    },
    templates: {
      settings: 'Le tue impostazioni',
      title: 'Modelli',
      tile: 'Modelli',
      tileSub:
        'I tuoi testi e i modelli della scuola per inviti, conferme e rifiuti',
      tab: {
        PERSONAL: 'I miei modelli',
        SCHOOL: 'Modelli della scuola',
      },
      intro: {
        PERSONAL:
          'I tuoi testi personali. Fino a 3 per tipo, li vedi solo tu. Salvi nuovi modelli direttamente mentre scrivi con «Salva come modello».',
        SCHOOL:
          'Testi per tutta la scuola. Fino a 3 per tipo. Tutte le persone con diritti di scrittura possono usarli, solo titolare, admin e HR possono modificarli.',
      },
      org: 'Scuola',
      noOrg:
        'Non appartieni a nessuna scuola. I modelli della scuola esistono solo per il personale di una scuola.',
      count: '{{count}} di {{max}}',
      empty: {
        PERSONAL:
          'Ancora nessun modello personale. Scrivi un/una {{kind}}, adatta il testo e scegli «Salva come modello».',
        SCHOOL:
          'Ancora nessun modello della scuola per questo tipo. Scrivendo un/una {{kind}}, salvalo con «Tutta la scuola».',
      },
      subject: 'Oggetto',
      savedAt: 'Salvato il {{date}}',
      name: 'Nome del modello',
      placeholders:
        'Segnaposto: {vorname}, {nachname}, {stelle}, {absender}, {schule}',
      edit: 'Modifica',
      editLabel: 'Modifica il modello {{name}}',
      deleteLabel: 'Elimina il modello {{name}}',
      save: 'Salva',
      cancel: 'Annulla',
      delete: 'Elimina',
      deleteTitle: 'Eliminare il modello «{{name}}»?',
      deleteText:
        'Il modello scompare da «I miei modelli». I messaggi già inviati restano invariati.',
      deleteTextSchool:
        'Il modello scompare per tutta la scuola. I messaggi già inviati restano invariati.',
      saved: 'Modello salvato.',
      deleted: 'Modello eliminato.',
      forbidden:
        'Solo titolare, admin e HR possono modificare i modelli della scuola.',
      failed: 'Non ha funzionato. Riprova.',
      loadFailed: 'Non è stato possibile caricare i modelli.',
      retry: 'Riprova',
      footer:
        'Prima di eliminare Bildigsnetz chiede conferma. I modelli standard di Bildigsnetz restano sempre disponibili.',
    },
    language: {
      title: 'Lingua',
      hint: 'Vale per l’app e per tutte le e-mail di Bildigsnetz',
      saved: 'Lingua salvata',
      failed: 'Non è stato possibile salvare la lingua. Riprova.',
    },
  },
  login: {
    title: 'Ciao!',
    intro:
      'Con il tuo account accedi ai profili dei professionisti e a tutte le possibilità di Bildigsnetz.',
    email: 'E-mail',
    password: 'Password',
    passwordRequired: 'Inserisci la tua password.',
    submit: 'Accedi',
    edulog: 'Accedi con Edulog',
    google: 'Accedi con Google',
    noAccount: 'Non hai ancora un account?',
    signup: 'Registrati',
    forgotPassword: 'Password dimenticata?',
    error: {
      credentials: 'L’indirizzo e-mail o la password non sono validi.',
      tooManyRequests: 'Troppi tentativi. Attendi qualche minuto e riprova.',
      offline:
        'Nessuna connessione. Controlla la connessione a Internet e riprova.',
      server:
        'I tuoi dati di accesso sono corretti, ma non siamo riusciti a caricare il tuo profilo. Riprova tra qualche minuto.',
    },
  },
  authError: {
    otherProvider:
      'Il tuo account è già collegato a un altro metodo di accesso (ad es. Google o e-mail).',
    emailInUse: 'Questo indirizzo e-mail è già in uso.',
    invalidEmail: 'L’indirizzo e-mail non è valido.',
    wrongPassword: 'La password non è corretta.',
    tooManyRequests: 'Troppi tentativi. Attendi qualche minuto e riprova.',
    offline:
      'Nessuna connessione. Controlla la connessione a Internet e riprova.',
    userDisabled: 'Questo account è bloccato. Contatta il supporto.',
    unknown: 'Si è verificato un errore.',
  },
  signup: {
    title: 'Registrati gratuitamente',
    subtitle: 'Il tuo profilo è pronto in un minuto.',
    email: 'E-mail',
    emailPlaceholder: 'nome@esempio.ch',
    emailInvalid: 'L’indirizzo e-mail non è valido.',
    emailRequired: 'L’indirizzo e-mail è obbligatorio.',
    password: 'Password',
    passwordHelp: 'Cosa rende sicura una password?',
    passwordHint: 'Almeno 8 caratteri, con maiuscole, minuscole e un numero.',
    passwordRequired: 'Inserisci una password.',
    passwordWeak:
      'La password è troppo debole: almeno 8 caratteri, con maiuscole, minuscole e un numero.',
    showPassword: 'Mostra password',
    hidePassword: 'Nascondi password',
    newsletter: 'Desidero ricevere la newsletter',
    termsBefore: 'Registrandoti accetti le',
    terms: 'CG',
    termsBetween: ', la',
    privacy: 'dichiarazione sulla protezione dei dati',
    termsAnd: 'e la',
    cookies: 'politica sui cookie',
    termsAfter: '.',
    submit: 'Crea account',
    or: 'oppure',
    edulog: 'Registrati con Edulog',
    google: 'Registrati con Google',
    haveAccount: 'Hai già un account?',
    login: 'Accedi',
    error: 'Si è verificato un errore. Riprova più tardi.',
    benefitsTitle: 'I tuoi vantaggi con un profilo',
    benefits: {
      apply: {
        title: 'Candidarsi in pochi clic',
        text: 'Salva i documenti una volta e riutilizzali per ogni candidatura.',
      },
      chat: {
        title: 'Chattare direttamente',
        text: 'Scrivi facilmente a scuole e ad altri professionisti.',
      },
      push: {
        title: 'Notifiche sul telefono',
        text: 'Risposte delle scuole e nuovi posti subito sul telefono, con Bildigsnetz sulla schermata Home.',
      },
      searchAgent: {
        title: 'Abbonamento di ricerca personale',
        text: 'Ricevi automaticamente per e-mail i nuovi posti adatti a te.',
      },
      applications: {
        title: 'Gestire le candidature',
        text: 'Tutte le candidature e il loro stato in un unico posto.',
      },
      profile: {
        title: 'Profilo professionale',
        text: 'Mostra i tuoi punti di forza e ricevi richieste dalle scuole.',
      },
      network: {
        title: 'Rete',
        text: 'Scopri professionisti e trova opportunità di visite in classe.',
      },
    },
  },
  receivedApplications: {
    backToJobs: 'Torna ad annunci e candidature',
    title: 'Panoramica candidature',
    tileHint: 'Clicca su uno stato per filtrare',
    filterByStatus: 'Filtra per stato',
    toolbar: 'Adatta la vista',
    search: 'Cerca nome o e-mail',
    status: {
      ALL: 'Tutte',
      PENDING: 'In esame',
      INVITED: 'Invitato/a',
      ACCEPTED: 'Accettata',
      REJECTED: 'Rifiutata',
      WITHDRAWN: 'Ritirata',
    },
    sort: {
      label: 'Ordinamento',
      NEWEST: 'Ricezione, più recenti prima',
      OLDEST: 'Ricezione, meno recenti prima',
      RATING: 'Valutazione',
      NAME: 'Nome dalla A alla Z',
    },
    filter: {
      label: 'Filtri',
      rating: 'Valutazione',
      unrated: 'Non ancora valutata',
      membership: 'Iscrizione',
      MEMBER: 'Solo membri',
      GUEST: 'Senza account',
      period: 'Ricezione',
      periodALL: 'Tutte le date',
      period7: 'Ultimi 7 giorni',
      period30: 'Ultimi 30 giorni',
      reset: 'Reimposta',
      close: 'Fatto',
    },
    view: {
      label: 'Vista',
      cards: 'Vista a schede',
      list: 'Vista a elenco',
    },
    rating: {
      label: 'Valutazione',
      set: 'Valutazione {{rating}}',
      current: 'Valutazione {{rating}}',
      none: 'Non ancora valutata',
      change: 'modifica',
      remove: 'Rimuovi valutazione',
      failed: 'Non è stato possibile salvare la valutazione.',
    },
    selection: {
      label: 'Selezione',
      count: '{{count}} selezionate',
      clear: 'Annulla selezione',
    },
    readOnly: {
      title: 'Hai accesso in sola lettura.',
      text: 'Vedi candidature e valutazioni. Può modificare solo chi ha diritti di scrittura.',
    },
    empty: {
      title: 'Ancora nessuna candidatura',
      job: 'Appena qualcuno si candida, la scheda appare sotto «In esame». Ricevi un’e-mail.',
      initiative: 'Qui appaiono le candidature senza un posto specifico.',
    },
    noMatch: 'Nessuna candidatura corrisponde alla ricerca o ai filtri.',
    loadFailed: 'Non è stato possibile caricare le candidature.',
    retry: 'Riprova',
    jobLoadFailed: 'Non è stato possibile caricare l’annuncio.',
    showMore: 'Mostra altri {{count}}',
    conflict:
      'Qualcuno ha appena modificato la candidatura. La panoramica è aggiornata.',
    changeDenied: 'Hai solo accesso in lettura a questa candidatura.',
    emptyColumn: 'Nessuna candidatura',
    dragHint:
      'Trascinare una scheda in un’altra colonna cambia solo lo stato, senza messaggio. Senza mouse: cambiare lo stato nel dossier.',
    emptyWithdrawn: 'Solo i candidati possono ritirare la candidatura.',
    expand: 'Espandi la colonna {{status}} con {{count}} candidature',
    collapse: 'Comprimi la colonna {{status}}',
    select: 'Seleziona {{name}}',
    selectAll: 'Seleziona tutte le candidature {{status}}',
    new: 'Nuova',
    member: 'Membro',
    guest: 'Non membro',
    applied: 'Ricevuta il',
    phone: 'Telefono',
    mail: 'E-mail',
    mailTo: 'E-mail a {{name}}',
    dossier: {
      back: 'Torna alla panoramica',
      jobs: 'Annunci & candidature',
      loading: 'Caricamento della candidatura …',
      loadFailed: 'Non è stato possibile caricare la candidatura.',
      accessDenied: {
        title: 'Nessun accesso a questa candidatura',
        text: 'Il tuo ruolo in questa scuola non permette di consultare le candidature. Rivolgiti al/alla proprietario/a o a un amministratore della scuola.',
      },
      readOnly:
        'Vedi il dossier e puoi scaricare i documenti. Solo chi ha i diritti di scrittura può modificare.',
      appliedFor: 'Candidatura per',
      status: 'Stato',
      statusFailed: 'Non è stato possibile modificare lo stato.',
      contact: 'Contatto',
      profile: 'Vedi profilo',
      guestHint:
        'Candidatura senza account: nessun profilo e nessuna chat. Raggiungibile per e-mail o telefono.',
      letterAndDocuments: 'Lettera di motivazione e documenti',
      downloadAll: 'Scarica tutto il dossier',
      downloading: 'Creazione del dossier …',
      downloadFailed: 'Non è stato possibile scaricare il dossier. Riprova.',
      zipName: 'Dossier di candidatura',
      noLetter: 'Nessuna lettera di motivazione.',
      documents: 'Documenti',
      docs: {
        cv: 'Curriculum vitae',
        tandemCv: 'CV del/della partner di jobsharing',
        diplomas: 'Diplomi e certificati',
        references: 'Certificati di lavoro e referenze',
      },
      noFile: 'Nessun file',
      download: 'Scarica {{name}}',
      open: 'Apri {{name}}',
      ratingHint:
        'La valutazione vale per tutto il team ed è visibile solo internamente.',
      notes: {
        title: 'Note',
        empty: 'Ancora nessuna nota.',
        add: 'Nuova nota',
        edit: 'Modifica',
        delete: 'Elimina',
        save: 'Salva',
        cancel: 'Annulla',
        hint: 'Le note sono visibili a tutte le persone autorizzate a vedere questa candidatura. La persona candidata non le vede mai.',
        failed: 'Non è stato possibile salvare la nota.',
        deleteTitle: 'Eliminare la nota?',
        deleteText:
          'La nota viene eliminata per tutti e non può essere ripristinata.',
        discardTitle: 'Scartare la nota?',
        discardText: 'La tua nota non è ancora salvata e andrà persa.',
        keepEditing: 'Continua a modificare',
      },
      messages: {
        loadFailed: 'Non è stato possibile caricare i messaggi.',
        title: 'Messaggi',
        empty: 'Ancora nessun messaggio inviato.',
        by: 'da {{name}}',
        retry: 'Invia di nuovo',
        retried: 'Verrà inviato di nuovo.',
        retryFailed: 'Il nuovo invio non è riuscito.',
        kind: {
          MESSAGE: 'Messaggio',
          INVITATION: 'Invito',
          ACCEPTANCE: 'Conferma',
          REJECTION: 'Rifiuto',
        },
        channel: {
          CHAT: 'Chat',
          EMAIL: 'E-mail',
        },
        state: {
          PENDING: 'in invio',
          SENDING: 'in invio',
          ACCEPTED: 'inviato',
          DELIVERED: 'recapitato',
          FAILED: 'non riuscito',
          BOUNCED: 'non recapitabile',
        },
      },
      history: {
        title: 'Cronologia',
        someone: 'Qualcuno',
        submitted: 'Candidatura ricevuta',
        status: '{{name}} ha impostato lo stato su «{{status}}»',
        rated: '{{name}} ha valutato con {{rating}}',
        unrated: '{{name}} ha rimosso la valutazione',
        viewed: '{{name}} ha aperto la candidatura',
        claimed: 'L’ospite ha creato un account',
      },
    },
    compose: {
      close: 'Chiudi',
      cancel: 'Annulla',
      backToMessage: 'Torna al messaggio',
      toOne: 'A {{name}}',
      toMany: 'A {{count}} persone',
      initiative: 'Candidatura spontanea',
      kindLabel: 'Tipo di messaggio',
      from: 'Da',
      via: 'via Bildigsnetz',
      replyTo: 'noreply@bildigsnetz.ch · Le risposte vanno a {{email}}',
      copyToMe: 'Inviami una copia',
      to: 'A',
      ownMail: 'ogni persona riceve la propria e-mail',
      channel: {
        label: 'Invia tramite',
        CHAT_AND_EMAIL: 'Chat ed e-mail',
        CHAT_AND_EMAIL_sub: 'Messaggio in chat, e-mail come avviso',
        EMAIL_ONLY: 'Solo e-mail',
        EMAIL_ONLY_sub: 'Come per le persone senza profilo',
        mixed:
          '{{members}} persone su {{total}} sono membri. Le altre ricevono il messaggio solo per e-mail.',
      },
      guestOne:
        '{{name}} non è membro di Bildigsnetz e riceve il messaggio per e-mail.',
      guestMany:
        'Nessuna di queste persone è membro di Bildigsnetz. Tutte ricevono il messaggio per e-mail.',
      languageOther:
        'Modelli standard in {{language}}, la lingua della candidatura.',
      languageNames: { de: 'tedesco', fr: 'francese', it: 'italiano' },
      languageMixed:
        'Le candidature sono in lingue diverse. Un modello standard non modificato viene inviato a ogni persona nella sua lingua.',
      templates: {
        own: 'I miei modelli',
        school: 'Modelli della scuola',
        standard: 'Modelli standard',
        count: '{{count}} di 3',
        noneOwn:
          'ancora nessuno. Adatta un testo e salvalo in basso con «Salva come modello».',
      },
      subject: 'Oggetto',
      body: 'Messaggio',
      hintOne: 'Modificabile. {schule} viene sostituito all’invio.',
      hintMany:
        'Modificabile. {vorname} e {nachname} vengono sostituiti per ogni persona.',
      statusNote:
        'Dopo l’invio lo stato passa a «{{status}}». Prima non cambia nulla.',
      statusNoteMany:
        'Dopo l’invio lo stato di tutte le {{count}} persone passa a «{{status}}». Prima non cambia nulla.',
      quickNote: 'Viene inviato subito. Lo stato passa a «{{status}}».',
      sentOne: 'Messaggio inviato.',
      sentMany: '{{count}} messaggi inviati.',
      partial:
        '{{sent}} inviati. {{failed}} non hanno potuto essere inviati perché nel frattempo sono stati modificati.',
      failed: 'Il messaggio non ha potuto essere inviato.',
      templatesFailed: 'Non è stato possibile caricare i modelli.',
      unfilled:
        'Nel testo c’è ancora un segnaposto come [data]. Sostituiscilo e poi invia di nuovo.',
      discard: {
        title: 'Scartare il messaggio?',
        text: 'Il tuo testo non è ancora stato inviato e andrà perso.',
        confirm: 'Scarta',
        cancel: 'Continua a scrivere',
      },
      versionConflict:
        'Qualcuno ha modificato la candidatura nel frattempo. Il tuo testo è ancora qui. Verifica lo stato e invia di nuovo.',
      invalidTransition:
        'Lo stato della candidatura non permette più questo messaggio. Non è stato inviato.',
      withdrawn:
        'La candidatura è stata ritirata. Il messaggio non è stato inviato.',
      changedMeanwhile:
        'La candidatura è stata modificata nel frattempo. Il messaggio non è stato inviato.',
      skipped:
        '{{count}} su {{total}} vengono saltate perché il loro stato non lo permette, per esempio già rifiutate.',
      notPossible: 'Nello stato «{{status}}» questo messaggio non è possibile.',
      skippedBadge: 'Saltata',
      INVITATION: {
        short: 'Invito',
        plural: 'di invito',
        title: 'Scrivi un invito',
        quickTitle: 'Invia invito',
        send: 'Invia invito',
        sendQuick: 'Invia invito ora',
        sendMany: 'Invia {{count}} inviti',
        confirmTitle: 'Inviare {{count}} inviti?',
        confirmText:
          'Ognuna delle {{count}} persone riceve il proprio messaggio. Lo stato passa a «Invitato/a». Le e-mail inviate non si possono richiamare.',
      },
      ACCEPTANCE: {
        short: 'Conferma',
        plural: 'di conferma',
        title: 'Scrivi una conferma',
        quickTitle: 'Invia conferma rapida',
        send: 'Invia conferma',
        sendQuick: 'Invia conferma ora',
        sendMany: 'Invia {{count}} conferme',
        confirmTitle: 'Inviare {{count}} conferme?',
        confirmText:
          'Ognuna delle {{count}} persone riceve il proprio messaggio. Lo stato passa a «Confermato/a». Le e-mail inviate non si possono richiamare.',
      },
      REJECTION: {
        short: 'Rifiuto',
        plural: 'di rifiuto',
        title: 'Scrivi un rifiuto',
        quickTitle: 'Invia rifiuto rapido',
        send: 'Invia rifiuto',
        sendQuick: 'Invia rifiuto ora',
        sendMany: 'Invia {{count}} rifiuti',
        confirmTitle: 'Inviare {{count}} rifiuti?',
        confirmText:
          'Ognuna delle {{count}} persone riceve il proprio messaggio. Lo stato passa a «Rifiutato/a». Le e-mail inviate non si possono richiamare.',
      },
      saveTemplate: {
        open: 'Salva come modello',
        title: 'Salva come modello',
        fullTitle: 'Hai già 3 modelli {{kind}}',
        lead: 'Salva il testo per riutilizzarlo più tardi.',
        fullLead:
          'Per tipo ci sono 3 modelli personali e 3 modelli della scuola. Scegli quello che vuoi sostituire.',
        name: 'Nome del modello',
        nameHint:
          'La prossima volta Bildigsnetz adatta automaticamente nomi e denominazione del posto.',
        who: 'Chi può usare il modello?',
        personal: 'Solo io',
        personalSub: 'Appare sotto «I miei modelli»',
        school: 'Tutta la scuola',
        schoolSub:
          'Appare a tutti sotto «Modelli della scuola». Solo titolare, admin e HR',
        replace: 'Quale modello vuoi sostituire?',
        save: 'Salva',
        replaceSave: 'Sostituisci e salva',
        saved: 'Modello salvato.',
        forbidden:
          'Solo titolare, admin e HR possono salvare modelli della scuola.',
        limit: 'Ci sono già 3 modelli di questo tipo.',
        failed: 'Non è stato possibile salvare il modello.',
      },
    },
    actions: {
      label: 'Azioni',
      menu: 'Azioni per {{name}}',
      invite: 'Invitare',
      inviteSub: 'Colloquio, lezione di prova, giornata di prova',
      accept: 'Confermare',
      acceptSub: 'Messaggio personale',
      quickAccept: 'Conferma rapida',
      quickSub: 'Testo standard, inviato subito',
      onlySingle: 'Possibile solo per una singola candidatura',
      reject: 'Rifiutare',
      rejectSub: 'Messaggio personale',
      quickReject: 'Rifiuto rapido',
      tooMany: 'Al massimo 50 alla volta.',
    },
    initiative: {
      title: 'Candidature spontanee',
      subtitle: 'Candidature senza un posto specifico',
      link: 'Candidature spontanee',
    },
  },
  applyForm: {
    backJob: 'Torna al posto',
    backSchool: 'Torna al profilo della scuola',
    forJob: 'La tua candidatura per',
    forInitiative: 'La tua candidatura spontanea a',
    badge: {
      fulltime: 'Posto fisso',
      substitute: 'Supplenza',
      temporary: 'Impiego a tempo determinato',
      initiative: 'Candidatura spontanea',
    },
    hello: {
      member: 'Ciao {{name}}, quasi fatto',
      memberInitiative: 'Ciao {{name}}, che bello vederti',
      guest: 'Candidatura come ospite',
      guestInitiative: 'Che bello vederti!',
    },
    intro: {
      member:
        'I dati del tuo profilo sono già inseriti. Completa ciò che manca e invia.',
      guest: 'Senza account, direttamente alla scuola.',
      initiative:
        'Anche senza un posto messo a concorso, la scuola è felice di conoscerti.',
    },
    progress: '{{done}} passi su {{total}} completati',
    progressLabel: 'Avanzamento della candidatura',
    duration: {
      member: 'Circa 2 minuti',
      guest: 'Circa 4 minuti',
    },
    requiredNote: 'I campi obbligatori sono contrassegnati con *.',
    stepDone: ', passo {{n}} completato',
    stepOpen: ', passo {{n}} di {{total}}',
    step: {
      personal: {
        job: 'Dati personali',
        initiative: 'Su di te',
      },
      qualification: {
        job: 'La tua qualifica',
        initiative: 'La tua qualifica',
      },
      message: {
        job: 'Messaggio alla scuola',
        initiative: 'Raccontati alla scuola',
      },
      docs: {
        job: 'I tuoi documenti',
        initiative: 'I tuoi documenti',
      },
      confirm: {
        job: 'Conferme',
        initiative: 'Conferme',
      },
    },
    personal: {
      memberNote:
        'Questi dati valgono solo per questa candidatura. Il tuo profilo resta invariato.',
      profileName: 'Nome dal tuo profilo',
      salutation: 'Appellativo',
      birthDate: 'Data di nascita',
      firstName: 'Nome',
      lastName: 'Cognome',
      email: 'E-mail',
      phone: 'Telefono',
      street: 'Via e n.',
      postalCode: 'NPA',
      city: 'Località',
    },
    salutation: {
      FEMALE: 'Signora',
      MALE: 'Signor',
      NONE: 'Nessuna indicazione',
    },
    qualification: {
      help: 'Per la professione per cui ti candidi. La scuola può ordinare secondo questo criterio.',
      DIPLOMA: {
        title: 'Diplomato/a',
        text: 'Formazione conclusa o diploma riconosciuto per questa professione.',
      },
      BASE_YEAR_COMPLETED: {
        title: 'Anno di base superato',
        text: 'In formazione, il primo anno è stato superato.',
      },
      TRAINING: {
        title: 'Inizio della formazione',
        text: 'In formazione, il primo anno è in corso.',
      },
      NON_SPECIALIST: {
        title: 'Senza formazione specifica',
        text: 'Senza formazione in questa professione, per esempio cambio di carriera.',
      },
    },
    message: {
      label: 'Motivazione o lettera di candidatura',
      placeholder: 'Caro team …',
      help: {
        job: 'Bastano alcune frasi personali, oppure incolla la tua lettera di candidatura.',
        initiative:
          'Che cosa ti appassiona, che cosa porti? Bastano alcune frasi.',
      },
    },
    docs: {
      memberNote:
        'Ripreso dal tuo dossier di candidatura. Puoi rimuovere o aggiungere file per questa candidatura.',
      cv: 'Curriculum vitae',
      cvUpload: 'Carica il curriculum',
      diplomas: 'Diplomi e certificati',
      tandemCv: '2° curriculum (solo per candidatura in tandem)',
      tandemCvUpload: 'Carica il 2° curriculum',
      references: 'Certificati di lavoro e altro',
      filesUpload: 'Carica file',
      formats: 'PDF, DOC o DOCX, al massimo 5 MB ciascuno.',
    },
    confirm: {
      terms:
        'I miei dati sono corretti e accetto le CG e l’informativa sulla protezione dei dati.',
      criminalRecord:
        'Confermo che nel mio casellario giudiziale non figurano condanne non cancellate, che contro di me non è in corso alcun procedimento penale e che non sussiste alcun divieto formale o di fatto di esercitare la professione (né in Svizzera né all’estero).',
      required: 'Sono necessarie entrambe le conferme.',
    },
    footNote: {
      member:
        'Riceverai una conferma per e-mail. Lo stato è visibile in «Le mie candidature».',
      guest: 'Riceverai una conferma per e-mail.',
    },
    cancel: 'Annulla',
    send: 'Invia candidatura',
    sendInitiative: 'Invia candidatura spontanea',
    failed: {
      alreadyApplied:
        'Ti sei già candidato/a per questo posto. Finché questa candidatura è aperta, non è possibile inviarne una seconda.',
      closed: 'Questo posto non accetta più candidature.',
      notPublished: 'Questo posto non è più messo a concorso.',
      notYetPublished: 'Questo posto non è ancora messo a concorso.',
      expired: 'Il termine di candidatura per questo posto è scaduto.',
      disabled: 'Al momento non è possibile candidarsi.',
      fileUnreadable:
        'Non è stato possibile leggere un file. Caricalo di nuovo.',
      fileNotOwned: 'Un file non appartiene al tuo account. Caricalo di nuovo.',
      offline:
        'Nessuna connessione. Controlla la connessione internet e riprova.',
      generic: 'Si è verificato un errore. Riprova.',
    },
    error: {
      salutation: 'Scegli un appellativo.',
      birthDate: 'Indica la tua data di nascita.',
      birthDateRange: 'Controlla la data di nascita.',
      firstName: 'Indica il tuo nome.',
      lastName: 'Indica il tuo cognome.',
      email: 'Indica il tuo indirizzo e-mail.',
      emailFormat:
        'Inserisci un indirizzo e-mail valido, per esempio nome@esempio.ch.',
      phone:
        'Indica il tuo numero di telefono, così la scuola può contattarti.',
      street: 'Indica via e numero.',
      postalCode: 'Indica l’NPA.',
      city: 'Indica la località.',
      qualification: 'Scegli a che punto sei nella tua professione.',
      message: 'Scrivi alcune frasi alla scuola.',
    },
  },
  applyChoice: {
    title: {
      job: 'La tua candidatura',
      initiative: 'La tua candidatura spontanea',
    },
    back: {
      job: 'Torna al posto',
      initiative: 'Torna alla scuola',
    },
    question: 'Come vuoi candidarti?',
    profile: {
      title: 'Candidarti con un profilo',
      recommended: 'Consigliato',
      text: 'Crea il tuo profilo gratuito in un minuto. Ecco cosa ti offre:',
      signup: 'Registrati gratis e candidati',
      hasAccount: 'Hai già un account?',
      login: 'Accedi e continua',
    },
    guest: {
      title: 'Candidarti come ospite',
      text: {
        job: 'Senza account, solo per questo posto. Carichi i tuoi documenti direttamente.',
        initiative:
          'Senza account, solo per questa scuola. Carichi i tuoi documenti direttamente.',
      },
      upload: 'Caricare CV e documenti per questa candidatura',
      again: 'Per altre candidature ricarichi tutto',
      start: 'Continua come ospite',
    },
  },
  applicationSent: {
    title: 'Candidatura inviata',
    titleInitiative: 'Candidatura spontanea inviata',
    textJobGuest:
      'La tua candidatura come {{job}} è arrivata a {{school}}. La conferma viene inviata a {{email}}.',
    textJobMember:
      'La tua candidatura come {{job}} è arrivata a {{school}}. Lo stato lo trovi in «Le mie candidature».',
    textInitiativeGuest:
      'La tua candidatura spontanea è arrivata a {{school}}. La conferma viene inviata a {{email}}.',
    textInitiativeMember:
      'La tua candidatura spontanea è arrivata a {{school}}. Lo stato lo trovi in «Le mie candidature».',
    close: 'Chiudi',
    later: 'No, grazie',
    ok: 'Fatto',
    finishProfile: 'Completa il profilo',
    moreJobs: 'Vedi altri posti',
    toApplications: 'Alle mie candidature',
    offer: {
      title: 'Il tuo profilo è quasi pronto',
      text: 'I tuoi dati sono stati ripresi. Mancano solo due passi, circa un minuto.',
      stepsLabel: 'Crea il profilo',
      stepTaken: 'Dati e documenti ripresi',
      stepEmail: "Conferma l'indirizzo e-mail",
      stepPassword: 'Imposta la password',
      done: 'fatto',
      benefitsTitle: 'Cosa ti offre il tuo profilo',
      benefitOneClick: 'Candidarti con un clic, i tuoi documenti sono salvati',
      benefitStatus: 'Vedere lo stato delle candidature in tempo reale',
      benefitChat: 'Chattare con la scuola, con notifica push sul telefono',
      benefitAlert: 'Posti adatti con l’abbonamento ai posti',
    },
  },
  guestOnboarding: {
    title: 'Quasi fatto, {{name}}',
    text: 'Il tuo indirizzo e-mail è confermato. Manca solo la tua denominazione professionale.',
    later:
      'Disponibilità e foto del profilo le potrai aggiungere più tardi nel tuo profilo.',
    submit: 'Crea profilo',
    qualificationMissing:
      'Rispondi alla domanda sulla qualifica per ogni denominazione professionale.',
  },
  guestWelcome: {
    title: 'Benvenuto su Bildigsnetz',
    text: 'Il tuo profilo è pronto. Trovi la tua candidatura in «Le mie candidature».',
    applications: 'Le mie candidature',
    jobs: 'Vedi posti aperti',
    close: 'Chiudi',
    hintTitle:
      'Perché le scuole ti trovino: aggiungi disponibilità e foto del profilo',
    hintText: 'Mancano solo poche informazioni.',
    hintAction: 'Completa il profilo',
  },
  initiativeApply: {
    cardTitle: 'Candidatura spontanea',
    cardText:
      'Nessun posto adatto? Invia una candidatura spontanea a {{school}}.',
    start: 'Invia una candidatura spontanea',
    noPostingNeeded: 'nessun posto a concorso necessario',
    intro: 'Anche senza un posto pubblicato, la scuola è felice di conoscerti.',
    missing: 'Non abbiamo trovato questa scuola.',
    allSchools: 'Tutte le scuole',
    fileMissing: 'Non è stato possibile leggere un file. Caricalo di nuovo.',
    listHint: 'Candidatura senza posto pubblicato',
    error: {
      alreadyApplied:
        'Hai già inviato una candidatura spontanea qui. Finché è aperta, non è possibile inviarne una seconda.',
      disabled: 'Le candidature spontanee al momento non sono possibili.',
      notPublished:
        'Questa scuola al momento non accetta candidature spontanee.',
      generic: 'Si è verificato un errore. Riprova.',
    },
  },
};
